import React, { useContext } from 'react'
import styles from './styles.module.css'
import { ListOfFacility } from '@s4l/stayforlong/property/domain/ListOfFacility'
import type { Facility } from '@s4l/stayforlong/property/domain/Facility'
import { useS4LContext } from '@s4l/react-context'
import MappedIconText from './MappedIconText'
import { PropertyCardContext } from '../context'
import cn from 'classnames'

export const MAX_FACILITIES_TO_SHOW = 3

// prettier-ignore
const FACILITY_TRANSLATION_MAP: Record<string, string> = {
    // Featured facilities
    'air-conditioner': 'global.air-conditioner',
    'airport-shuttle': 'global.airport-shuttle',
    'parking': 'global.car-park', 
    'car-park': 'global.car-park', 
    'garage': 'global.car-park', 
    'gym': 'global.gym', 
    'receptionist': 'global.24h-reception', 
    '24-hour-reception': 'global.24h-reception',
    'safe': 'global.safebox', 
    'spa': 'global.spa', 
    'pool': 'global.pool', 
    'outdoor': 'global.outdoor-pool', 
    'outdoor-pool': 'global.outdoor-pool', 
    'indoor': 'global.indoor-pool', 
    'indoor-pool': 'global.indoor-pool', 
    'wheelchair': 'global.wheelchair', 
    'wifi-alt': 'global.wifi',
    'wifi': 'global.wifi', 
    'wi-fi': 'global.wifi',
    'freeCancellation':  'global.free-cancellation',
    'accessible': 'facilities.accessible',
    'wheelchair-access': 'global.accessible',
  
    // Common facilities
    'air-conditioning-in-public-areas': 'global.air-conditioner',
    'centrally-regulated-air-conditioning': 'global.air-conditioner',
    'individually-adjustable-air-conditioning': 'global.air-conditioner',
    'breakfast': 'global.breakfast', 
    'hotel-safe': 'global.safebox',
    'restaurant': 'global.restaurant', 
    'terrace': 'global.terrace', 
}

interface FacilitiesProps {
  facilitiesJSON?: ReturnType<ListOfFacility['toJSON']>
  hide?: boolean
}

export const Facilities = ({ facilitiesJSON, hide = false }: FacilitiesProps) => {
  const { i18n } = useS4LContext()
  const { variant, isSoldOut } = useContext(PropertyCardContext)

  if (!facilitiesJSON) return null

  if (hide || isSoldOut) {
    return null
  }

  const listofFacilities = ListOfFacility.fromJSONOrEmpty({ json: facilitiesJSON })

  if (listofFacilities.isEmpty()) {
    return null
  }

  const validFacilities = listofFacilities
    .uniqueById()
    .filter((facility: Facility) => {
      const translationKey = FACILITY_TRANSLATION_MAP[facility.id]
      return !!translationKey
    })
    .take(MAX_FACILITIES_TO_SHOW)

  if (validFacilities.isEmpty()) {
    return null
  }

  return (
    <div
      className={cn(styles.container, {
        [styles.fixedHeight]: variant === 'fixed-height',
      })}
    >
      {validFacilities.map((facility: Facility) => {
        const translationKey = FACILITY_TRANSLATION_MAP[facility.id]
        const translatedText = i18n.formatMessage({ id: translationKey })

        return <MappedIconText key={facility.id} facilityId={facility.id} text={translatedText} />
      })}
    </div>
  )
}
